// Adapted approach and used https://mui.com/components/autocomplete/#free-solo as template

import React from "react";
import {TextField} from "@mui/material";
import {useStyles} from "./SuggestionTextField.css";
import {AddCircle} from "@mui/icons-material";
import {Autocomplete, createFilterOptions} from "@mui/material";

const SuggestionTextFieldMulti = ({id, label, placeholder, existingOptions, value, onChange, disabled, variant='outlined', ...props}) => {
    const classes = useStyles()
    const filter = createFilterOptions()

    // Enrich the provided existingOptions list with additional data (necessary for the "add" suggestion)
    const enrichedOptions = existingOptions.map((option) => {
        return {title: option, existing: true}
    })

    return (
        <Autocomplete
            {...props}
            id={id}
            autoHighlight
            autoSelect
            multiple
            selectOnFocus
            clearOnBlur
            handleHomeEndKeys
            freeSolo
            options={enrichedOptions}
            value={value}

            // IMPORTANT: initial values have no title, but newly selected options have - therefore use the following fallback approach
            onChange={(event, value) => onChange(value?.map((v) => v?.title || v) || [])}

            filterOptions={(options, params) => {
                const filtered = filter(options, params);
                const {inputValue} = params;

                // If the typed option is not included in the available list, add it as new option (with "existing = false")
                const isExistingOption = options.some((option) => inputValue.toUpperCase() === option.title.toUpperCase());
                if (inputValue !== '' && !isExistingOption) {
                    filtered.push({
                        title: inputValue,
                        existing: false
                    });
                }

                return filtered;
            }}
            // Source/Idea: https://github.com/mui-org/material-ui/issues/30123
            isOptionEqualToValue={(option, value) => {
                const optionTitle = option?.title || option
                const valueTitle = value?.title || value
                return optionTitle === valueTitle
            }}
            getOptionLabel={(option) => {
                if (typeof option === 'string') {
                    return option;
                }
                return option.title || ''
            }}
            renderOption={(props, option) =>
                <li {...props}>{option.existing ? option.title :
                    <div className={classes.addLabel}>
                        <AddCircle className={classes.addIcon}/>
                        <div>'{option.title}'</div>
                    </div>}</li>}
            renderInput={(params) => (
                <TextField {...params}
                           required
                           variant={variant}
                           label={label}
                           placeholder={placeholder}/>
            )}
            disabled={disabled}
        />
    );
}

export default SuggestionTextFieldMulti